import link from '../annotations/link'
import productLink from '../annotations/product-link'
import small from '../decorators/small'

export default {
  title: 'Text',
  name: 'text',
  type: 'array',
  of: [
    {
      type: 'block',
      styles: [],
      lists: [],
      marks: {
        decorators: [
          { title: 'Strong', value: 'strong' },
          { title: 'Emphasis', value: 'em' },
          small
        ],
        annotations: [link, productLink]
      }
    }
  ]
}
